export class MoovStepScheduleDTO{
    public id!: number;
    public executeOnOrAfter!: string;
    public startedAt!: string;
    public finishedAt!: string;
    public inProgress!: boolean;
    public finished!: boolean;
}